import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaCheckCircle,
  FaPhoneAlt,
  FaCalendarAlt,
  FaClock,
  FaUndoAlt,
  FaHome,
  FaFileAlt,
} from "react-icons/fa";
import "../../css/deletionRequestSuccess.css";

export default function DeletionRequestSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);
  const { requestId, mobileNumber, deletionDate } = location.state || {};

  useEffect(() => {
    if (!requestId) {
      navigate("/");
      return;
    }

    // Auto redirect to home after 10 seconds
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, requestId]);

  if (!requestId) {
    return null;
  }

  // Calculate days remaining until deletion
  const daysRemaining = deletionDate
    ? Math.max(
        0,
        Math.ceil(
          (new Date(deletionDate) - new Date()) / (1000 * 60 * 60 * 24),
        ),
      )
    : 30;

  return (
    <div className="success-page-container">
      <div className="success-page-content">
        <div className="success-animation">
          <div className="success-circle">
            <FaCheckCircle className="success-main-icon" />
          </div>
        </div>

        <h1>Account Deletion Requested</h1>
        <p className="subtitle">
          Your account will be deleted in {daysRemaining} days
        </p>

        <div className="request-details-card">
          <div className="details-grid">
            <div className="detail-item">
              <FaFileAlt className="detail-icon" />
              <div>
                <label>Request ID</label>
                <p>{requestId}</p>
              </div>
            </div>
            <div className="detail-item">
              <FaPhoneAlt className="detail-icon" />
              <div>
                <label>Mobile Number</label>
                <p>{mobileNumber}</p>
              </div>
            </div>
            <div className="detail-item">
              <FaCalendarAlt className="detail-icon" />
              <div>
                <label>Deletion Date</label>
                <p>
                  {deletionDate
                    ? new Date(deletionDate).toLocaleDateString()
                    : `${daysRemaining} days from now`}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grace-period-banner">
          <div className="grace-countdown">
            <FaClock className="countdown-icon" />
            <div>
              <span>Time remaining to cancel</span>
              <h2>{daysRemaining} Days</h2>
            </div>
          </div>
        </div>
        <div className="redirect-message">
          <p>Redirecting to Login page in {countdown} seconds...</p>
        </div>
      </div>
    </div>
  );
}
